import Vue from 'vue'

import {
    ArrowUpIcon
} from 'vue-feather-icons';

import Navbar from "@/components/navbar";
import Switcher from "@/components/switcher";
import Footer from "@/components/footer";

import axios from 'axios';

/**
 * Shop checkouts component
 */
export default {
    data() {
        return {
            valid: true,
            title: null,
            systemEmail: null,
            domainName: null,
            password: null,
            comfirmPassword: null,
            modalRegister: false,
            textResult: null,
            overlay: false,
            requiredRules: [
                (v) => !!v || "กรุณากรอกข้อมูลให้ครบถ้วน"
            ],
        }
    },
    components: {
        Navbar,
        Switcher,
        Footer,
        ArrowUpIcon
    },
    computed: {
        checkForm() {
            return !this.title ||
                !this.systemEmail ||
                !this.domainName ||
                !this.password ||
                !this.comfirmPassword ||
                this.comfirmPassword != this.password ||
                this.password < 8
        },
        passwordRules() {
            const rules = [];
            rules.push((v) =>
                v.length >= 8 || "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป"
            );

            return rules;
        },
        conFirmPasswordRules() {
            const rules = [];
            rules.push((v) =>
                (!!v && v) === this.password || "กรุณากรอกรหัสผ่านให้ตรงกัน"
            );
            rules.push((v) =>
                v.length >= 8 || "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป"
            );
            return rules;
        },
    },
    methods: {
        reserveCompany() {
            this.overlay = true
            axios.post(`/company/manage/reserve`, {
                title: this.title,
                systemEmail: this.systemEmail,
                domainName: this.domainName,
            }).then(res => {
                // console.log(res.data.result._id);
                let id = res.data.result._id;

                return this.insertUser(id)
            }).then(resp => {
                // console.log(resp)
                this.$router.replace({
                    path: "/login"
                });
            }).catch((err) => {
                this.$bvModal
                    .msgBoxOk(
                        err.response.data.message,
                        {
                            title: "Can not register",
                            centered: true,
                        }
                    )
                console.log(err);
            }).finally(() => {
                this.overlay = false
            });
        },
        insertUser(id) {
            return axios.post(`/account/tula/register/admin`, {
                username: this.systemEmail,
                password: this.password,
                firstName: "Admin",
                lastName: this.title,
                image: "",
                active: true,
                studentCode: "",
                gender: "male",
                email: this.systemEmail,
                identificationNumber: "",
                companies: [id], //
                user_groups: [],
                isTeacher: "y",
                permission: {
                    adminCompany: true,

                    viewTutor: true,
                    viewStudent: true, //ข้อมูลผู้ใช้
                    insertStudent: true, //เพิ่มรายชื่อ
                    updateStudent: true, //แก้ไขรายชื่อผู้ใช้
                    activeStudent: true, //ระงับการใช้งาน

                    viewCourse: true, //เข้าถึงคอร์ส
                    insertCourse: true, //เพิ่มคอร์ส
                    updateCourse: true, //แก้ไขคอร์ส
                    activeCourse: true, //ระงับคอร์ส

                    viewCategory: true, //จัดการ Category
                    insertCategory: true, //จัดการ Category
                    updateCategory: true, //จัดการ Category
                    activeCategory: true, //จัดการ Category

                    viewBanner: true, //จัดการ Banner
                    insertBanner: true, //จัดการ Banner
                    updateBanner: true, //จัดการ Banner
                    activeBanner: true, //จัดการ Banner

                    viewReport: true, //เข้าถึงการรายงาน

                    viewCompany: false,
                    insertCompany: false,
                    updateCompany: false,
                    activeCompany: false,

                    viewUserGroup: true, //จัดการกลุ่มผู้ใช้
                    insertUserGroup: true, //จัดการกลุ่มผู้ใช้
                    updateUserGroup: true, //จัดการกลุ่มผู้ใช้
                    activeUserGroup: true, //จัดการกลุ่มผู้ใช้

                    accessBI: false
                }
            })
        },
    }
}